export const rotatePoint = (p, r) => {
    if (r > 0) {
        r -= 360;
    }
    while (r < 0) {
        r += 90;
        p = {
            x:  p.y,
            y: -p.x,
        };
    }
    return p;
};
